import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_EMAIL_SENDS } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowEmailSends = {
  namespaced: true,
  state: buildInitialState({
    workflowEmailSendList: []
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowEmailSends ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading emails, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_EMAIL_SENDS, parameters: filters })
        .then(json => json.data)
        .then(sends => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowEmailSends', sends)
          return sends
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load emails')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getWorkflowEmailSend (context, { id }) {
      return api.doGet({ path: `${PATH_WORKFLOW_EMAIL_SENDS}/${id}` }).then(json => json.data)
    },
    approveWorkflowEmailSend ({ dispatch }, { id }) {
      showProgressModal({ dispatch, message: 'Approving and sending, please wait...' })
      return api.doPost({ path: `${PATH_WORKFLOW_EMAIL_SENDS}/${id}/approve` })
        .then(response => {
          if (!response.data) {
            throw new Error(response.errorMessage || 'Unable to approve this email.')
          }
          notifySuccess(dispatch, 'Email approved and sent')
          return response
        })
        .catch(error => {
          notifyError(dispatch, error || 'Unable to approve this email')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    rejectWorkflowEmailSend ({ dispatch }, { id, rejectionReason }) {
      showProgressModal({ dispatch, message: 'Rejecting, please wait...' })
      return api.doPost({ path: `${PATH_WORKFLOW_EMAIL_SENDS}/${id}/reject`, data: { rejectionReason } })
        .then(response => {
          if (!response.data) {
            throw new Error(response.errorMessage || 'Unable to reject this email.')
          }
          notifySuccess(dispatch, 'Email rejected')
          return response
        })
        .catch(error => {
          notifyError(dispatch, error || 'Unable to reject this email')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowEmailSends (state, sends) {
      state.workflowEmailSendList = sends
    }
  }
}

export default workflowEmailSends
